
import React, { Component } from "react";
import {Icon} from 'antd';
import moment from 'moment'
//import AmbItnSVPriceListView from '../../amb/AmbItnSVPriceListView'
import AmbLocationSVPriceListViewShort from '../amb/AmbLocationSVPriceListViewShort'
import AmbItnSVPriceListViewShort from '../amb/AmbItnSVPriceListViewShort'

const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

class AmbOfferItnReview extends Component {
    morderPriceView( svcustProfile, reservekey, priceInfo){
        let odisplay = { hide:true}
        
        if(priceInfo &&  (!priceInfo.o  ) ){
            return (<div></div>)
        }
        return ( <AmbLocationSVPriceListViewShort   priceInfo={priceInfo} svcustProfile={svcustProfile} reservekey={reservekey}  odisplay={odisplay} ></AmbLocationSVPriceListViewShort>
                 
            )

    }
    morderItnsView( svcustProfile, reservekey, legs){
        
        if(legs &&  (legs.length < 1 ) ){
            return (<div></div>)
        }
        return legs.map( (itn, idx) =>{
             let odirtypef = { t: "F"}
             let odirtyper = { t: "R"}
               if(idx == 0){
                return (<AmbItnSVPriceListViewShort  odirtype={odirtypef}  svitn={itn} svcustProfile={svcustProfile} reservekey={reservekey}  ></AmbItnSVPriceListViewShort>
                    )
               }else{
                return (<AmbItnSVPriceListViewShort  odirtype={odirtyper} svitn={itn} svcustProfile={svcustProfile} reservekey={reservekey}  ></AmbItnSVPriceListViewShort>
                    )
               }
                

        })

    }

    constructor(props) {
        super(props)
        let me = this
        this.morderItnsView = this.morderItnsView.bind(this)
        this.morderPriceView = this.morderPriceView.bind(this)
       
        this.reloadReviewPageSV = this.reloadReviewPageSV.bind(me)
        this.getPanelHdr = this.getPanelHdr.bind(this)
        this.getPanelBody = this.getPanelBody.bind(this)
        this.getPanelBody_long = this.getPanelBody_long.bind(this)
        
        this.callbackAc = this.callbackAc.bind(this)
        this.state = {
            expandIconPosition: 'left',
          }
        
      
        this.location = {
            "resort_name": "253 Mancreek Resort",
            "address_line1": " 253 scottland av",
            "county": "albanyt",
            "postalcode": 12193,
            "market_code": "NAMER",
            "country": "usa",
            "region_desc_en": [
                "United States",
                "Coastal Mid Atlantic"
            ],
            "state": "NY",
        }

       

    }
    
    reloadReviewPageSV=(ob )=>(e)=>{
        let me = this
        console.log('sv****Got the page reloadPageSV needs customerId')
        console.log(ob)
        let cidOffer = null
        if(me.props.priceInfo.o){
            console.log('SVOCT25 Step1 2********')
            cidOffer = me.props.priceInfo.o
            
            //cookies.set('svcook', this.props.priceInfo.o, { path: '/' });
        }
        me.props.svofferselectparent(cidOffer, ob.flight_space_key) 
       // history.back(-1)
       

      // history.push(`/myaccountSV/6/svaddress/-1`)
        

    }
    componentWillMount()	{
        console.log('sv--task=--- link sends us params')
       
       console.log(this.props);
      
      
       
      console.log('sv-cook********2' )
     


    console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:')
       
  

   
       // this.props.priceAndTexNow(id);
   
			
			
	

	}
    getPanelBody(seg){
        let  momsega = moment(seg.arrival.at);
        let sega_s = momsega.format('hh:mm A') 
        let  momsegd = moment(seg.departure.at);
        let segd_s = momsegd.format('hh:mm A') 
        return (
            <div className="o-container-flist">
            <div className="o-box-flist-b1" style={{width:"270px"}} style={{width:"270px"}}>
                <span className="o-span">
                
                        
                            
                            
                            <span>
                            <p className="m-para-text">
                            <span style={{fontSize: "14px"}} > <Icon  style={{ fontSize:'18px', color: 'rgb(55, 173, 219)' }} type="dashboard" theme="filled" /><text style={{color:'#cc8e3b', fontSze:'16px',  paddingLeft: "10px", paddingRight:'20px'}}>{segd_s }</text><Icon type="line" /><text style={{ color: '#122196' }} style={{color:'#cc8e3b', fontSze:'16px', paddingLeft: "20px"}}>{sega_s }</text></span>
                                
                                <text style={{fontSize:'14px'}} className="svr-hotel-room d-block" >  {seg.carrierCode  }{seg.number  }  - Aircraft {seg.aircraft.code  } </text>
                                <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ca61a1', opacity:'0.9', fontSize:'16px' }} type="account-book" theme="filled" /><text style={{paddingLeft: "10px", color:'#898995'}}>Operated By SAM</text></span>
        
                            </p>
                            </span>
                        
                    
        
                
                </span>
            </div>
            <div className="o-box-flist" style={{width:"270px"}}>
                <span className="o-span">
                    
                            <p className="m-para-text">
                            <span style={{fontSize: "14px"}} > <text style={{fontSize:'14px',color:'#768999'}} >{seg.duration }</text><Icon style={{paddingLeft: "10px", color: 'rgb(126, 181, 230)' , fontSize:'14px'}} type="cloud-upload"   /><text style={{fontSize:'14px',color:'#768999',paddingLeft: "10px"}} >Overnight Flight</text></span>
                                <text style={{fontSize:'14px'}} className="svr-hotel-room d-block"> 1h 42 m in DEN </text>
                                <text style={{fontSize:'12px',color:'#898995'}} className="f12  d-block"> {seg.carrierCode  }{seg.number  } </text>
                            </p>
                        
                </span>
        </div>                       
    </div>
        )
    }
    getPanelBody_long(seg){
        let  momsega = moment(seg.arrival.at);
        let sega_s = momsega.format('hh:mm A') 
        let  momsegd = moment(seg.departure.at);
        let segd_s = momsegd.format('hh:mm A') 
        return (
            <div className="o-container-flist">
            <div className="o-box-flist-b1" >
                <span className="o-span">
                
                        
                            
                            
                            <span>
                            <p className="m-para-text">
                            <span style={{fontSize: "14px"}} > <Icon  style={{ fontSize:'18px', color: 'rgb(55, 173, 219)' }} type="dashboard" theme="filled" /><text style={{color:'#cc8e3b', fontSze:'16px',  paddingLeft: "10px", paddingRight:'20px'}}>{seg.departure.at }</text><Icon type="line" /><text style={{ color: '#122196' }} style={{color:'#cc8e3b', fontSze:'16px', paddingLeft: "20px"}}>{seg.arrival.at }</text></span>
                                
                                <text style={{fontSize:'14px'}} className="svr-hotel-room d-block" >  {seg.carrierCode  }{seg.number  }  - Aircraft {seg.aircraft.code  } </text>
                                <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ca61a1', opacity:'0.9', fontSize:'16px' }} type="account-book" theme="filled" /><text style={{paddingLeft: "10px", color:'#898995'}}>Operated By SAM</text></span>
        
                            </p>
                            </span>
                        
                    
        
                
                </span>
            </div>
            <div className="o-box-flist">
                <span className="o-span">
                    
                            <p className="m-para-text">
                            <span style={{fontSize: "14px"}} > <text style={{fontSize:'14px',color:'#768999'}} >{seg.duration }</text><Icon style={{paddingLeft: "10px", color: 'rgb(126, 181, 230)' , fontSize:'14px'}} type="cloud-upload"   /><text style={{fontSize:'14px',color:'#768999',paddingLeft: "10px"}} >Overnight Flight</text></span>
                                <text style={{fontSize:'14px'}} className="svr-hotel-room d-block"> 1h 42 m in DEN </text>
                                <text style={{fontSize:'12px',color:'#898995'}} className="f12  d-block"> {seg.carrierCode  }{seg.number  } </text>
                            </p>
                        
                </span>
        </div>                       
    </div>
        )
    }
    getPanelHdr(seg){
        return (<span style={{fontSize: "14px"}} > <Icon  style={{ fontSize:'18px', color: 'rgb(55, 173, 219)' }} type="box-plot" theme="filled" /><text style={{color:'#cc8e3b', fontSze:'18px',  paddingLeft: "10px", paddingRight:'20px'}} >{seg.departure.iataCode}</text><text style={{color:'#cc8e3b', fontSze:'16px',  paddingLeft: "10px", paddingRight:'20px'}}>{seg.departure.at }</text><Icon type="line" /><text style={{color:'#cc8e3b', fontSze:'18px',  paddingLeft: "10px", paddingRight:'20px'}} >{seg.arrival.iataCode}</text><text style={{ color: '#122196' }} style={{color:'#cc8e3b', fontSze:'16px', paddingLeft: "20px"}}>{seg.arrival.at }</text></span>
        )
    }
    onPositionChange = expandIconPosition => {
    this.setState({ expandIconPosition });
  };
    callbackAc(key){
        console.log(key);

    }
    
    
    getStepBody(){
        return (<p>I am sweet</p>)
    }
   
   

    deleteTaskCurryParams = (param1, ctx)=>(event)=>{
        console.log(param1)
		let me = ctx
		me.currentSelection = param1.sojourncode
		console.log('sv delete task curry')
		console.log(param1.sojourncode)
		//me.props.svWrappedDeleteTaskActionCreator(param1.id)
	}
   

    render() {
        /*
 let svr_fly = {
      "startdate": soj['startdate'] ? soj['startdate'] : "06:30",
                                        "enddate": soj['enddate'] ? soj['enddate'] : "7:30",
                                        "flight_arrival_daytime": soj['flight_arrival_daytime'] ? soj['flight_arrival_daytime'] : "AM",
                                        "flight_departure_daytime": soj['flight_departure_daytime'] ? soj['flight_departure_daytime'] : "PM",

                                        "origin_airport_code": soj['origin_airport_code'] ? soj['origin_airport_code'] : "SJC",
                                        "origincity": soj['origincity'] ? soj['origincity'] : "Sajn Jose",
                                        "dst_airport_code": soj['dst_airport_code'] ? soj['dst_airport_code'] : "AUS",
                                        "destcity": soj['destcity'] ? soj['destcity'] : "Austin",
                                        "airlines_name": soj['airlines_name'] ? soj['airlines_name'] : "Delta Airlines",
                                        

                                    }
        */
     const {svcustProfile, priceInfo} = this.props
     let offer = priceInfo.o
     console.log('sv****OCT23 priceInfo.o ', offer)
     /*
       const offer = {
        "type": "flight-offer",
        "id": "1",
        "source": "GDS",
        "instantTicketingRequired": false,
        "nonHomogeneous": false,
        "oneWay": false,
        "isUpsellOffer": false,
        "lastTicketingDate": "2024-10-24",
        "lastTicketingDateTime": "2024-10-24",
        "numberOfBookableSeats": 1,
        "itineraries": [
            {
                "duration": "PT46H34M",
                "segments": [
                    {
                        "departure": {
                            "iataCode": "EWR",
                            "terminal": "B",
                            "at": "2024-11-01T19:59:00"
                        },
                        "arrival": {
                            "iataCode": "LAX",
                            "terminal": "6",
                            "at": "2024-11-01T23:10:00"
                        },
                        "carrierCode": "AS",
                        "number": "287",
                        "aircraft": {
                            "code": "7M9"
                        },
                        "operating": {
                            "carrierCode": "AS"
                        },
                        "duration": "PT6H11M",
                        "id": "1",
                        "numberOfStops": 0,
                        "blacklistedInEU": false
                    },
                    {
                        "departure": {
                            "iataCode": "LAX",
                            "terminal": "6",
                            "at": "2024-11-02T19:45:00"
                        },
                        "arrival": {
                            "iataCode": "ANC",
                            "terminal": "S",
                            "at": "2024-11-03T00:19:00"
                        },
                        "carrierCode": "AS",
                        "number": "193",
                        "aircraft": {
                            "code": "73H"
                        },
                        "operating": {
                            "carrierCode": "AS"
                        },
                        "duration": "PT5H34M",
                        "id": "2",
                        "numberOfStops": 0,
                        "blacklistedInEU": false
                    },
                    {
                        "departure": {
                            "iataCode": "ANC",
                            "terminal": "S",
                            "at": "2024-11-03T13:30:00"
                        },
                        "arrival": {
                            "iataCode": "ADQ",
                            "at": "2024-11-03T14:33:00"
                        },
                        "carrierCode": "AS",
                        "number": "89",
                        "aircraft": {
                            "code": "73H"
                        },
                        "operating": {
                            "carrierCode": "AS"
                        },
                        "duration": "PT1H3M",
                        "id": "3",
                        "numberOfStops": 0,
                        "blacklistedInEU": false
                    }
                ]
            }
        ],
        "price": {
            "currency": "USD",
            "total": "1446.23",
            "base": "1324.63",
            "fees": [
                {
                    "amount": "0.00",
                    "type": "SUPPLIER"
                },
                {
                    "amount": "0.00",
                    "type": "TICKETING"
                }
            ],
            "grandTotal": "1446.23"
        },
        "pricingOptions": {
            "fareType": [
                "PUBLISHED"
            ],
            "includedCheckedBagsOnly": true
        },
        "validatingAirlineCodes": [
            "AS"
        ],
        "travelerPricings": [
            {
                "travelerId": "1",
                "fareOption": "STANDARD",
                "travelerType": "ADULT",
                "price": {
                    "currency": "USD",
                    "total": "1446.23",
                    "base": "1324.63"
                },
                "fareDetailsBySegment": [
                    {
                        "segmentId": "1",
                        "cabin": "BUSINESS",
                        "fareBasis": "KH0OASFN",
                        "brandedFare": "FR",
                        "brandedFareLabel": "FIRST",
                        "class": "C",
                        "includedCheckedBags": {
                            "quantity": 2
                        },
                        "amenities": [
                            {
                                "description": "SEAT ASSIGNMENT",
                                "isChargeable": false,
                                "amenityType": "PRE_RESERVED_SEAT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "MEAL 1",
                                "isChargeable": false,
                                "amenityType": "MEAL",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "PRIORITY BOARDING",
                                "isChargeable": false,
                                "amenityType": "TRAVEL_SERVICES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "110V AC POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "USB POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGEABLE TICKET",
                                "isChargeable": false,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            }
                        ]
                    },
                    {
                        "segmentId": "2",
                        "cabin": "BUSINESS",
                        "fareBasis": "KH0OASFN",
                        "brandedFare": "FR",
                        "brandedFareLabel": "FIRST",
                        "class": "C",
                        "includedCheckedBags": {
                            "quantity": 2
                        },
                        "amenities": [
                            {
                                "description": "SEAT ASSIGNMENT",
                                "isChargeable": false,
                                "amenityType": "PRE_RESERVED_SEAT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "MEAL 1",
                                "isChargeable": false,
                                "amenityType": "MEAL",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "PRIORITY BOARDING",
                                "isChargeable": false,
                                "amenityType": "TRAVEL_SERVICES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "110V AC POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "USB POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGEABLE TICKET",
                                "isChargeable": false,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            }
                        ]
                    },
                    {
                        "segmentId": "3",
                        "cabin": "BUSINESS",
                        "fareBasis": "KH0OASFN",
                        "brandedFare": "FR",
                        "brandedFareLabel": "FIRST",
                        "class": "C",
                        "includedCheckedBags": {
                            "quantity": 2
                        },
                        "amenities": [
                            {
                                "description": "SEAT ASSIGNMENT",
                                "isChargeable": false,
                                "amenityType": "PRE_RESERVED_SEAT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "MEAL 1",
                                "isChargeable": false,
                                "amenityType": "MEAL",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "PRIORITY BOARDING",
                                "isChargeable": false,
                                "amenityType": "TRAVEL_SERVICES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "110V AC POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "USB POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGEABLE TICKET",
                                "isChargeable": false,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    }
    */
    let {itineraries} = offer
     //svj18start
    let reservekey = 'inambofferitnreview'
        //svj18end
    if(!itineraries){
        itineraries = []
    }
    let itn = itineraries[0]
    let segStart = itn.segments[0] 
    let sum_org = segStart.departure.iataCode
    let n = itn.segments.length
    let segEnd = itn.segments[n-1]
    let sum_departure = segStart.departure.at
    let  momIsoStartDate = moment(sum_departure);
    let sum_departure_s = momIsoStartDate.format('hh:mm A') 
    let sum_departure_s_long = momIsoStartDate.format('hh:mm A, MMM DD, YY') 

    
   
    let sum_arrival = segEnd.arrival.at
    let  momIsoEndDate = moment(sum_arrival);
    let sum_arrival_s = momIsoEndDate.format('hh:mm A') 
    let sum_dst = segEnd.arrival.iataCode
    let sum_stops = n -1
    let sum_duration = itn.duration
    let sum_departure_daytime = 'AM'
    let sum_arrival_daytime = 'PM'
    let sum_airlines = segStart.carrierCode
    let flight_airline_num_stops = 3
    /*
       const  itn = {
        "duration": "PT46H34M",
        "segments": [
            {
                "departure": {
                    "iataCode": "EWR",
                    "terminal": "B",
                    "at": "2024-11-01T19:59:00"
                },
                "arrival": {
                    "iataCode": "LAX",
                    "terminal": "6",
                    "at": "2024-11-01T23:10:00"
                },
                "carrierCode": "AS",
                "number": "287",
                "aircraft": {
                    "code": "7M9"
                },
                "operating": {
                    "carrierCode": "AS"
                },
                "duration": "PT6H11M",
                "id": "1",
                "numberOfStops": 0,
                "blacklistedInEU": false
            },
            {
                "departure": {
                    "iataCode": "LAX",
                    "terminal": "6",
                    "at": "2024-11-02T19:45:00"
                },
                "arrival": {
                    "iataCode": "ANC",
                    "terminal": "S",
                    "at": "2024-11-03T00:19:00"
                },
                "carrierCode": "AS",
                "number": "193",
                "aircraft": {
                    "code": "73H"
                },
                "operating": {
                    "carrierCode": "AS"
                },
                "duration": "PT5H34M",
                "id": "2",
                "numberOfStops": 0,
                "blacklistedInEU": false
            },
            {
                "departure": {
                    "iataCode": "ANC",
                    "terminal": "S",
                    "at": "2024-11-03T13:30:00"
                },
                "arrival": {
                    "iataCode": "ADQ",
                    "at": "2024-11-03T14:33:00"
                },
                "carrierCode": "AS",
                "number": "89",
                "aircraft": {
                    "code": "73H"
                },
                "operating": {
                    "carrierCode": "AS"
                },
                "duration": "PT1H3M",
                "id": "3",
                "numberOfStops": 0,
                "blacklistedInEU": false
            }
        ]
    } */
        const { expandIconPosition } = this.state;
        const ars = [];
        let svrstars = {
            "sv_rating_no": 5,
            "sv_rating":"Excellent",
            "color": "#e8a01899"
        }
        console.log('###############  npt needed this.props.svrlocation ****************')
       
        let customerId = -1
       

        //const {o} = priceInfo
        let o = {
            product_cost_amount : '1030',
            avg_stars_rating : 5,
            flight_space_key: "1@4@1@ADQ"
        }
        console.log('############### price ****************')
        console.log(o)
        let flight_owner_message = 'Delta operated by SV DBA Deltaz Connection'
        let fltight_name = ''
        
        if(svcustProfile && svcustProfile.customerId ){
            if(typeof(svcustProfile.customerId) == "string"){
                customerId = parseInt(svcustProfile.customerId )
            }else{
                customerId = svcustProfile.customerId
            }
            if(customerId > 0){
           console.log('myreservationSpace')
           }else{
            console.log('internet userSpace')
           }
        }

        return (

            <div className="o-container-flist">
           
                <div className="svr-header2" style={{marginLeft:'14px'}}>
            <p className="sd-content"> <text> Travel Details </text></p>
                    {this.morderPriceView(svcustProfile, reservekey, priceInfo)}
                    <div style={{marginLeft:"5px"}}>
                    {
                     this.morderItnsView(svcustProfile, reservekey, itineraries)}
                     </div>
                    {/*  
                    <AmbItnSVPriceListView   svitn={itn} svcustProfile={svcustProfile} reservekey={reservekey}  ></AmbItnSVPriceListView>
               
                    */}
                 </div>
               
                
                
            </div>
          
        )
    }

 
}


export default AmbOfferItnReview